import { h } from "omi";

import { NWButton } from "@/components/atoms/nw-button";
import { NWIcon } from "@/components/atoms/nw-icon";
import { useAnalyticsService } from "@/services/analyticsService";

export type MobileModalData = {};

export const MobileModal = () => {
  const handleOnClick = () => {
    useAnalyticsService().trackMobileBannerRemindMeClicked();
  };

  return (
    <div className="bg-leather flex flex-col px-6 py-8 text-white h-[90svh] rounded-xl pointer-events-auto">
      <div className="h-fit flex items-center justify-center gap-4 text-white">
        <NWIcon name="nextwork-white" height={40} width={40}></NWIcon>
        <span className="text-lg">nextwork.org</span>
      </div>
      <div className="h-full flex items-center justify-center flex-col text-center space-y-2 pb-24">
        <div className="flex justify-center">
          <img src="/static/images/gifs/eyes-emoji.gif" alt="" width={140} />
        </div>
        <div class="space-y-6">
          <h1 className="text-2xl font-semibold leading-tight">At this stage NextWork is designed for desktop only.</h1>
          <p className="">
            Check it out when you're ready, or{" "}
            <a
              className="underline underline-offset-4 font-medium"
              href="https://calendly.com/maximus-nextwork/remind-me-to-start-my-aws-project"
              target="_blank"
              onClick={handleOnClick}
            >
              set a reminder
            </a>
            . See you there! 👋
          </p>
        </div>
      </div>

      <div class="w-full space-y-4 flex flex-col justify-center">
        <NWButton
          size={"full"}
          type="secondary"
          href={"https://calendly.com/maximus-nextwork/remind-me-to-start-my-aws-project"}
          target="_blank"
          onClick={handleOnClick}
        >
          Remind me!
        </NWButton>
      </div>
    </div>
  );
};
